<script lang="ts">
  import { createOrderDetailsQuery } from "../queries/order";
  import TextNew from "../components/TextNew.svelte";
  import ArrowLeft from "../components/icons/ArrowLeft.svelte";
  import OrderSummary from "../components/OrderSummary.svelte";
  import OrderProducts from "../components/OrderProducts.svelte";
  import LoadingSpinner from "../components/LoadingSpinner.svelte";

  export let params: { id?: string } = {};

  $: orderQuery = createOrderDetailsQuery(params.id ?? "");
  $: order = $orderQuery.data;
</script>

<div class="container">
  <header>
    <a href="#/report">
      <ArrowLeft />
      <span class="title">
        <TextNew size="xl" weight="medium">back to invoices</TextNew>
      </span>
    </a>
  </header>

  {#if $orderQuery.isLoading}
    <div class="loading-container">
      <LoadingSpinner size={60} />
    </div>
  {:else}
    <div class="content">
      {#if order}
        <div class="summary">
          <OrderSummary {order} />
        </div>

        <div class="products">
          <OrderProducts orderItems={order.items} />
        </div>
      {:else}
        <TextNew>Error loading order</TextNew>
      {/if}
    </div>
  {/if}
</div>

<style>
  .container {
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: white;
    height: 100vh;
    padding: 28px 24px 0 24px;
  }

  .container header {
    margin-bottom: 16px;
  }

  .container header a {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 12px;
    text-decoration: none;
  }

  .container header .title {
    margin-top: 4px;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh;
  }

  .content {
    height: 100vh;
    overflow: auto;
  }
  .summary {
    margin-top: 32px;
  }

  .products {
    margin-top: 32px;
    padding-bottom: 24px;
  }
</style>
